import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

import Button from '@mui/material/Button';

import classes from './HomeBanner.scss';

import videoBack from './videoBack.mp4';
import videoBackWebm from './videoBack.webm';
import poster from './videoBack.jpg';

export default function Banner() {
  const { t } = useTranslation(['main'])
  const isIos = navigator && !!navigator.platform && /iPhone|iPod/.test(navigator.platform)
  const showVideo = !isIos;
  const year = (new Date()).getFullYear();

  return (
    <div className={classes.homeBanner}>
      {showVideo && (
        <video preload="auto" poster={poster} autoPlay={true} loop={true} muted={true} playsInline={true} className={classes.videoBack}>
          <source src={videoBack} />
          <source src={videoBackWebm} />
        </video>
      )}
      <div className={classes.videoBackFlow} />
      <div className={classes.content}>
        <div className={classes.wrapper}>
          <div className={classes.years}>2011—{year}</div>

          <h1 className={classes.title}>
            {t('banner.title')}
          </h1>

          <div className={classes.columns}>
            <div className={classes.column}>
              <div className={classes.columnContent} dangerouslySetInnerHTML={{ __html: t('banner.advertiser') }} />

              <Button variant="contained" color="primary" component={Link} to={'/main/advertiser'}>
                {t('banner.advertiser_button')}
              </Button>
            </div>

            <div className={classes.column}>
              <div className={classes.columnContent} dangerouslySetInnerHTML={{ __html: t('banner.publisher') }} />

              <Button variant="contained" color="primary" component={Link} to={'/main/publisher'}>
                {t('banner.publisher_button')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
